import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

class TierAccountService {
  getAllSoldesBySocieteAndClient(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountURL() +
        "/getAllSoldesBySocieteAndClient/" +
        idUser +
        "/" +
        idTier
    );
  }
  getFicheClientInfoByTiers(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountRetailURL() +
        "/getFicheClientInfoByTiers/" +
        idUser +
        "/" +
        idTier
    );
  }

   getFicheFournisseurInfoByTiers(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountRetailURL() +
        "/getFicheFournisseurInfoByTiers/" +
        idUser +
        "/" +
        idTier
    );
  }

  getEcheancesFicheClientByTiers(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountRetailURL() +
        "/getEcheancesFicheClientByTiers/" +
        idUser +
        "/" +
        idTier
    );
  }

   getEcheancesFicheFournisseurByTiers(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountRetailURL() +
        "/getEcheancesFicheFournisseurByTiers/" +
        idUser +
        "/" +
        idTier
    );
  }
  getImpeyedFicheClientByTiers(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountRetailURL() +
        "/getImpeyedFicheClientByTiers/" +
        idUser +
        "/" +
        idTier
    );
  }


    getImpeyedFicheFournisseurByTiers(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountRetailURL() +
        "/getImpeyedFicheFournisseurByTiers/" +
        idUser +
        "/" +
        idTier
    );
  }
  getGeneralInfoBySociete(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountRetailURL() +
        "/getGeneralInfoBySociete/" +
        idUser
    );
  }

   getGeneralInfoBySocieteFournisseur(idUser) {
    return api.get(
      UtilsUrl.tierAccountRetailURL() +
        "/getGeneralInfoBySocieteFournisseur/" +
        idUser
    );
  }
  getAllSoldesBySociete(idUser) {
    return api.get(
      UtilsUrl.tierAccountURL() + "/getAllSoldesBySociete/" + idUser
    );
  }

  getSoldeById(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountURL() + "/getSoldeById/" + idUser + "/" + idTier
    );
  }

  getSoldeByIdFournisseur(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountRetailURL() + "/getSoldeById/" + idUser + "/" + idTier
    );
  }

  getSoldeAndWalletById(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountURL() +
        "/getSoldeAndWalletById/" +
        idUser +
        "/" +
        idTier
    );
  }

  findTransactionByAccount(idUser, idAccount) {
    return api.get(
      UtilsUrl.tierAccountURL() +
        "/findTransactionByAccount/" +
        idUser +
        "/" +
        idAccount
    );
  }

  findTransactionByAccountFournisseur(idUser, idAccount) {
    return api.get(
      UtilsUrl.tierAccountRetailURL() +
        "/findTransactionByAccount/" +
        idUser +
        "/" +
        idAccount
    );
  }


   findPayementByPayementInfo(idUser, idPI) {
    return api.get(
      UtilsUrl.payementAchatURL() +
        "/findPayementByPayementInformation/" +
        idUser +
        "/" +
        idPI
    );
  }

  createWalletTiersClient(walletModel) {
    return api.post(
      UtilsUrl.tierAccountURL() + "/createWalletTiers",
      walletModel
    );
  }
  getAllWalletClient(idUser) {
    return api.get(UtilsUrl.tierAccountURL() + "/getAllWallet/" + idUser);
  }
  getAllSoldeClient(idUser) {
    return api.get(UtilsUrl.tierAccountURL() + "/getAllSoldeClient/" + idUser);
  }
  getWalletByTier(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountURL() + "/getWalletByTier/" + idUser + "/" + idTier
    );
  }

  addWalletPayement(walletModel) {
    return api.post(
      UtilsUrl.tierAccountURL() + "/addWalletPayement",
      walletModel
    );
  }

  // Wallet fournisseur
  createWalletTiersFournisseur(walletModel) {
    return api.post(
      UtilsUrl.tierAccountRetailURL() + "/createWalletTiers",
      walletModel
    );
  }

  getAllWalletFournisseur(idUser) {
    return api.get(UtilsUrl.tierAccountRetailURL() + "/getAllWallet/" + idUser);
  }
  addWalletPayementFournisseur(walletModel) {
    return api.post(
      UtilsUrl.tierAccountRetailURL() + "/addWalletPayement",
      walletModel
    );
  }

    addWalletPayementFournisseurMultiTraite(walletModel) {
    return api.post(
      UtilsUrl.tierAccountRetailURL() + "/addWalletPayementMultiTraite",
      walletModel
    );
  }

  getWalletByTierFournisseur(idUser, idTier) {
    return api.get(
      UtilsUrl.tierAccountRetailURL() +
        "/getWalletByTier/" +
        idUser +
        "/" +
        idTier
    );
  }
}
export default new TierAccountService();
